export function isKycApproved(status) {
  return status === 'approved' || status === 'verified';
}
